// extracted by mini-css-extract-plugin
module.exports = {"item":"Prices_item__pOHT9"};